// extracted by mini-css-extract-plugin
module.exports = {"banner":"NewsletterBanner-module--banner--3JQXH","text":"NewsletterBanner-module--text--EqdrN","button":"NewsletterBanner-module--button--3Z_kG"};